import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * The empty-state standard — DESIGN.md §13.5.
 *
 * "Every empty state teaches: what this view is for + its primary action …
 * never a blank pane." Making that a component rather than a convention is
 * what keeps it true as views multiply.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode;
  /** What this surface is. */
  title: string;
  /** Why it is empty, and what fills it. */
  description: string;
  /** The primary action, when there is one to offer. */
  action?: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed px-6 py-12 text-center',
        className,
      )}
    >
      {icon ? <div className="text-muted-foreground mb-1">{icon}</div> : null}
      <h3 className="text-sm font-semibold">{title}</h3>
      <p className="text-muted-foreground max-w-md text-sm">{description}</p>
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
